import ComingSoonContainer from '../../../components/pages/other/ComingSoon';

const ComingSoon = () => {
    return <ComingSoonContainer />
}

export default ComingSoon;
